// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import borderByState, { sizeVariantValues } from "@insite/mobius/FormField/formStyles";
import { getProp } from "@insite/mobius/utilities";
import resolveColor from "@insite/mobius/utilities/resolveColor";
import DropdownIcons from "@mcmc/XDL/Components/DropdownIcons";
import { xBaseTheme } from "@mcmc/XDL/types";
import { css } from "styled-components";

export default {
    defaultProps: {
        cssOverrides: {
            dropdownWrapper: css`
                line-height: 20px;
                input {
                    text-indent: 25px;
                 }

                &[aria-expanded="true"] {
                    &&& > input {
                        ${(props: any) => borderByState(props, "inactive")}
                        outline: ${props => resolveColor("common.border", props.theme)} solid 2px;
                        outline-offset:-2px;
                        box-shadow: none;
                        border-bottom: none;
                        padding-bottom:0;
                    }

                    .chevron-icon {
                        transform: rotate(90deg); 
                    }
                }

            `,
            list: css`
                box-shadow: none;
                width: 100%;
                outline-color: ${getProp("theme.colors.common.border", "#09f")};
                outline-style: ${getProp("theme.focus.style", "solid")};
                outline-width: ${getProp("theme.focus.width", "2px")};
                outline-offset: -${getProp("theme.focus.width", "2px")};
                margin-top: -1px;
                // padding-top: 5px;
            `,
            option: css`
                padding: ${({ _sizeVariant }: any) => (_sizeVariant === "small" ? "5px 0 5px 11px" : "6px 0 6px 11px")};
                line-height: ${({ _sizeVariant }: any) => (_sizeVariant === "small" ? "20px" : "21px")};
                ${({ focused, disabled, selected, theme, noHover }: any) => {
                    let background = resolveColor("common.background", theme);
                    const text = resolveColor("text", theme);
                    const primary = resolveColor("common.ui3", theme);
                    const hover = primary;
                    if (selected) {
                        background = primary;
                    } else if (focused) {
                        background = hover;
                    }
                    return css`
                        background: ${background};
                        color: ${text};
                        ${!disabled &&
                        !noHover &&
                        `&:hover {
                            background: ${hover};
                            color: ${text};
                        }`}
                        ${disabled ? "cursor: not-allowed; opacity:0.5;" : "cursor: pointer;"}
                    `;
                }}
            `,
            noOptions: css`
                padding: ${({ _sizeVariant }: any) => (_sizeVariant === "small" ? "5px 0 5px 11px" : "6px 0 6px 11px")};
                line-height: ${({ _sizeVariant }: any) => (_sizeVariant === "small" ? "20px" : "21px")};
                color: ${({ theme }) => resolveColor("text", theme)};
                opacity: 0.5;
                cursor: not-allowed;
            `,
            selectedText: css`
                padding: 0 25px 0 35px;
                text-overflow: ellipsis;
                line-height: ${({ _sizeVariant }: any) => (sizeVariantValues as any)[_sizeVariant].height}px;
            `,
        },
        iconProps: {
            src: DropdownIcons,
            color: "secondary",
            size: 10,
            css: css`
                &&& {
                    position: static;
                    width: 0;
                    height: 0;
                    padding: 0;
                }
                .chevron-icon {
                    transform: rotate(-90deg);
                }
            `,
        },
    },
} as xBaseTheme["dynamicDropdown"];
